//导入vue-router
import vueRouter from "vue-router";
//导入vue
import Vue from "vue";
//注册vue-router
Vue.use(vueRouter);
import index from "../pages/index/index.vue";
import aboutUs from "../pages/aboutUs/aboutUs.vue";
import enterprise from "../pages/enterprise/enterprise.vue";
import contactUs from "../pages/contactUs/contactUs.vue";
import newsMobile from "../pages/news/newsMobile.vue";
import newsMobileDetails from "../pages/news/newsMobileDetails.vue";
import newsDetails from "../pages/news/newsDetails.vue";
import newsConsult from "../pages/news/newsConsult.vue";
import qiyeConsult from "../pages/news/qiyeConsult.vue";
import videoMedia from "../pages/news/videoMedia.vue";
import recruitCenter from "../pages/customer/recruitCenter.vue";

// 配置router
var router = new vueRouter({
    // mode: 'history',
    routes: [
        { path: "/", redirect: "/index" },
        { path: "/index", component: index, meta: { title: "云久鸿--首页" } },
        { path: "/aboutUs", component: aboutUs, meta: { title: "云久鸿--关于我们" } },
        { path: "/enterprise", component: enterprise, meta: { title: "云久鸿--企业服务" } },
        { path: "/contactUs", component: contactUs, meta: { title: "云久鸿--联系我们" } },
        { path: "/newsMobile", component: newsMobile, meta: { title: "云久鸿--新闻" } },
        { path: "/newsMobileDetails", component: newsMobileDetails, name: "newsMobileDetails", meta: { title: "云久鸿--新闻详情" } },
        { path: "/newsDetails", component: newsDetails, name: "newsDetails", meta: { title: "云久鸿--新闻详情" } },
        { path: "/newsConsult", component: newsConsult, meta: { title: "云久鸿--新闻咨询" } },
        { path: "/qiyeConsult", component: qiyeConsult, meta: { title: "云久鸿--企业咨询" } },
        { path: "/videoMedia", component: videoMedia, meta: { title: "云久鸿--视频媒体" } },
        { path: "/recruitCenter", component: recruitCenter, meta: { title: "云久鸿--招聘中心" } },
    ]
});

export default router;